import { NgProgress, NgProgressRef } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../modules/security/service/auth.service';

/**
 * This should extended by any concrete class that needs to operate directly with the API
 * endpoints and send feedback messages.
 */
export abstract class APIOperableComponent {
  protected loadingIndicator = false;
  protected progressRef: NgProgressRef;

  constructor(
    protected progressService: NgProgress,
    protected toastr: ToastrService,
    protected authService: AuthService
  ) {
    this.progressRef = progressService.ref();
  }

  /**
   * Stop any pending progress and shows an error to the User
   * @param message
   * @param title
   */
  protected onAPIError(errorMessage: string): void {
    this.finishProgress();
    this.toastr.error(errorMessage);
    this.loadingIndicator = false;
  }

  /**
   * Completes any pending progress and shows successfull message to the User
   * @param message
   * @param title
   */
  protected onAPISuccess(message): void {
    this.finishProgress();
    this.toastr.success(message);
  }

  /**
   * Return if the user has Admin Role
   */
  protected hasAdminRole() {
    return this.authService.isAdmin();
  }

  protected startProgress(): void {
    this.loadingIndicator = true;
    this.progressRef.start();
  }

  protected finishProgress(): void {
    this.loadingIndicator = false;
    this.progressRef.complete();
  }
}
